import { useSelector } from "react-redux";

const useAccountSenderPlaceholders = () => useSelector((state) => state.messaging.accountSenderPlaceholders);
const useAiFilters = () => useSelector((state) => state.messaging.aiFilters);
const useAllFilterAgents = () => useSelector((state) => state.messaging.allFilterAgents);
const useConflictConversation = () => useSelector((state) => state.messaging.conflictConversation);
const useConversations = () => useSelector((state) => state.messaging.conversations);
const useConversationsPage = () => useSelector((state) => state.messaging.conversationsPage);
const useConversationsPerPage = () => useSelector((state) => state.messaging.conversationsPerPage);
const useCurrentTab = () => useSelector((state) => state.messaging.currentTab);
const useDraftTextMessages = () => useSelector((state) => state.messaging.draftTextMessages);
const useErrors = () => useSelector((state) => state.messaging.errors);
const useFocusedConversation = () => useSelector((state) => state.messaging.focusedConversation);
const useHasMore = () => useSelector((state) => state.messaging.hasMore);
const useHasMoreMessages = () => useSelector((state) => state.messaging.hasMoreMessages);
const useHideAi = () => useSelector((state) => state.messaging.hideAi);
const useIsOptedOut = () => useSelector((state) => state.messaging.isOptedOut);
const useLoadingConversations = () => useSelector((state) => state.messaging.loadingConversations);
const useLoadingMessages = () => useSelector((state) => state.messaging.loadingMessages);
const useMessagesErrors = () => useSelector((state) => state.messaging.messagesErrors);
const useMessagesErrorsLink = () => useSelector((state) => state.messaging.messagesErrorsLink);
const useMessagesPage = () => useSelector((state) => state.messaging.messagesPage);
const useMessagesPerPage = () => useSelector((state) => state.messaging.messagesPerPage);
const useMessagingServiceUrl = () => useSelector((state) => state.messaging.messagingServiceUrl);
const useNewSmsMediaFile = () => useSelector((state) => state.messaging.newSmsMediaFile);
const useRecipientsHash = () => useSelector((state) => state.messaging.recipients);
const useSearchOpen = () => useSelector((state) => state.messaging.searchOpen);
const useSearchText = () => useSelector((state) => state.messaging.searchText);
const useSelectedAgentFilters = () => useSelector((state) => state.messaging.selectedAgentFilters);
const useSelectedMessages = () => useSelector((state) => state.messaging.selectedMessages);
const useSendingTextMessage = () => useSelector((state) => state.messaging.sendingTextMessage);
const useTwilioErrorMessage = () => useSelector((state) => state.messaging.twilioErrorMessage);
const useUnreadOnly = () => useSelector((state) => state.messaging.unreadOnly);

export {
  useAccountSenderPlaceholders,
  useAiFilters,
  useAllFilterAgents,
  useConflictConversation,
  useConversations,
  useConversationsPage,
  useConversationsPerPage,
  useCurrentTab,
  useDraftTextMessages,
  useErrors,
  useFocusedConversation,
  useHasMore,
  useHasMoreMessages,
  useHideAi,
  useIsOptedOut,
  useLoadingConversations,
  useLoadingMessages,
  useMessagesErrors,
  useMessagesErrorsLink,
  useMessagesPage,
  useMessagesPerPage,
  useMessagingServiceUrl,
  useNewSmsMediaFile,
  useRecipientsHash,
  useSearchOpen,
  useSearchText,
  useSelectedAgentFilters,
  useSelectedMessages,
  useSendingTextMessage,
  useTwilioErrorMessage,
  useUnreadOnly,
};
